<template>
        <div class="wrapper">
            <img src="../../assets/logo_blue.png" alt="Smiley face" id="logo">
            <div class="container">
                <div class="icon"/>
                <transition name="rollUp" mode="out-in">
                    <component @openRegister="selected_component='register'"
                               @openLogin="selected_component='login'"
                               @resetPassword="selected_component='resetPassword'"
                               :is="selected_component"
                    />
                </transition>
            </div>
        </div>
</template>

<script>
    import login from "./login";
    import register from "./register";
    import resetPassword from "./resetPassword";

    export default {
        name: "index",
        components: {login, register, resetPassword},
        data() {
            return {
                selected_component: 'login'
            }
        }
    }
</script>

<style scoped lang="scss">

    @media only screen and (max-width: 550px) {
        .container {
            width: 60vw;
        }
    }

    @media (min-width: 551px) and (max-width: 800px) {
        .container {
            width: 50vw;
        }
    }

    @media (min-width: 801px) and (max-width: 1200px) {
      .container {
        width: 35vw;
      }
    }

    @media (min-width: 1201px) and (max-width: 2500px){
        .container {
            width: 25vw;
        }
    }

    @media (min-width: 2500px){
      .container {
        width: 12vw;
      }
    }

    .wrapper {
        width: 100vw;
        height: 100vh;
        display: flex;
        position: relative;
        background: #F2C51722;
        flex-direction: column;

        #logo {
            margin: 3em auto 0 auto;
            height: auto;
            width: 12.5em;
        }

        .container {
            position: relative;
            display: flex;
            flex-direction: column;
            height: 400px;
            margin: 3em auto 0 auto;
            background: white;
            border-top: 0.25em solid #F2C517;
            box-sizing: border-box;
            border-top-left-radius: 2em;
            border-bottom-right-radius: 2em;
            box-shadow: 5px 0px 15px 5px rgba(0, 0, 0, 0.08);

            .icon {
                width: 2em;
                height: 1.75em;
                background: #F2C517;
                position: absolute;
                right: 0;
            }
        }

        .rollUp-enter-active, .rollUp-leave-active {
            transition: opacity .4s ease;
        }

        .rollUp-enter, .rollUp-leave-to {
            opacity: 0;
        }
    }
</style>
